<template>
<div>
    <div>        
        <main class="layoutContent">
            <!-- Encabezado contenido principal -->
            <header class="page-header">
                <div class="container pt-2">
                    <div class="row align-items-center justify-content-between">
                        <div class="col-auto pt-1">
                            <h1 class="page-header--title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                    class="bi bi-journal-bookmark" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M6 8V1h1v6.117L8.743 6.07a.5.5 0 0 1 .514 0L11 7.117V1h1v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8z" />
                                    <path
                                        d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z" />
                                    <path
                                        d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z" />
                                </svg>
                                Normativas y Documentación
                            </h1>
                            <p class="page-header--subtitle">Programa de vacaciones de Telefónica</p>
                        </div>
                        <div class="col-12">
                            <!-- <div class="input-group input-group-joined w-100">
                                <input class="form-control" type="text"
                                    placeholder="Búsqueda directa... Introduce hotel, zona o población."
                                    aria-label="Search" autofocus="">
                                <div class="input-group-append">
                                    <span class="input-group-text"><svg xmlns="http://www.w3.org/2000/svg"
                                            width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="feather feather-search">
                                            <circle cx="11" cy="11" r="8"></circle>
                                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                        </svg></span>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </header>
            <!-- Fin encabezado contenido principal -->

            <!-- Cuerpo contenido principal -->
            <div class="container content-body">
                <div class="row">

                    <div class="col h-100">
                        <!-- Bloque TARJETA CONTENIDO -->
                        <div class="card mb-4">
                            <div class="card-header d-flex flex-column flex-sm-row align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-file-earmark-text mr-1" viewBox="0 0 16 16">
                                    <path
                                        d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                                    <path
                                        d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                </svg>
                                Normas generales
                            </div>
                            <div class="card-body">
                                <!-- Comienzo del texto de las condiciones generales -->
                                <div class="container-grid">
                                    <a href="https://fondos-sociales.com/pdf/normas.verano.pdf" target="_blank">
                                        <div class="box d-flex lift p-3">
                                            <div class="box-icon">                                                
                                                <img :src="require('@/assets/css/img/icon-pdf.svg')" alt=""/>
                                            </div>
                                            <div class="box-content ml-2">
                                                <div class="font-weight-bold">Plan de Verano</div>
                                                <div>Normas generales</div>
                                            </div>
                                        </div>
                                    </a>
                                    <a href="https://fondos-sociales.com/pdf/normas.campamentos.pdf" target="_blank">
                                        <div class="box d-flex lift p-3">
                                            <div class="box-icon">
                                                <img :src="require('@/assets/css/img/icon-pdf.svg')" alt=""/>
                                            </div>
                                            <div class="box-content ml-2">
                                                <div class="font-weight-bold">Plan de Campamentos</div>
                                                <div>Normas generales</div>
                                            </div>
                                        </div>
                                    </a>

                                    <!-- <a href="pdf/Normas 2020 Verano.pdf" target="_blank">
                                        <div class="box d-flex lift p-3">
                                            <div class="box-icon">
                                                <img :src="require('@/assets/css/img/icon-pdf.svg')" alt=""/>
                                            </div>
                                            <div class="box-content ml-2">
                                                <div class="font-weight-bold">Plan de Semana Santa</div>
                                                <div>Normas generales</div>
                                            </div>
                                        </div>
                                    </a> -->
                                    <!-- <a href="https://fondos-sociales.com/pdf/medico.campamentos.pdf" target="_blank">
                                        <div class="box d-flex lift p-3">
                                            <div class="box-icon">
                                                <img :src="require('@/assets/css/img/icon-pdf.svg')" alt=""/>
                                            </div>
                                            <div class="box-content ml-2">
                                                <div class="font-weight-bold">Impreso autorización</div>
                                                <div>Médicos Campamentos</div>
                                            </div>
                                        </div>
                                    </a> -->

                                    <a href="https://fondos-sociales.com/pdf/normas.idiomas.pdf" target="_blank">
                                        <div class="box d-flex lift p-3">
                                            <div class="box-icon">
                                                <img :src="require('@/assets/css/img/icon-pdf.svg')" alt=""/>
                                            </div>
                                            <div class="box-content ml-2">
                                                <div class="font-weight-bold">Plan de Idiomas Extranjero</div>
                                                <div>Normas generales</div>
                                            </div>
                                        </div>
                                    </a>
                                </div>


                                <!-- Fin del texto de las condiciones generales -->

                            </div>
                            <div class="card-footer">
                                <!-- <p class="pl-3">Para acceso a Solicitudes ADJUDICADAS o en Reserva vea Menú
                                    Reservas.</p> -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Fin Cuerpo contenido principal -->
            </div>        
        </main>
    </div>
</div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'AppHeader',
  components: { //login,
  },
  data() {
    return {        
       
    }
  },

  created() {

  },
  computed: {
    ...mapState(['auth','errores']),

    logueado() {
        return this.auth.logueado;
    },   
    usuario() {
        return this.$store.state.auth.user;
    },

  },
   methods: {       

        desconectar() {
            if (!this.logueado) return;
            //alert('La sesion se ha desconectado ...');
            this.$store.commit('modal',{tit:"Desconectar",msg:"Se ha desconectado de la Sesion"});
            this.$store.commit('login_off');    
            this.$router.push('/');
        },



   }



    
}
</script>